import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ZonesInterventionPage from "./pages/ZonesInterventionPage";
import RSEPage from "./pages/RSEPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PostulerPage from "./pages/PostulerPage";
import RollupPage from "./pages/RollupPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import FAQPage from "./pages/FAQPage";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";

// ScrollToTop component - scrolls to top on route change or to anchor
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      // If there's a hash, scroll to that element
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  
  return null;
};

// Layout component that conditionally shows header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isRollupPage = location.pathname === "/rollup";
  
  return (
    <>
      {!isRollupPage && <Header />}
      <main className="flex-1">
        {children}
      </main>
      {!isRollupPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:serviceSlug" element={<ServiceDetailPage />} />
              <Route path="/zones-intervention" element={<ZonesInterventionPage />} />
              <Route path="/engagement-rse" element={<RSEPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/postuler" element={<PostulerPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/rollup" element={<RollupPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
              <Route path="/faq" element={<FAQPage />} />
            </Routes>
          </Layout>
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
